var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTurkey(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_5_34644)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12 24C18.6274 24 24 18.6274 24 12C24 5.37258 18.6274 0 12 0C5.37258 0 0 5.37258 0 12C0 18.6274 5.37258 24 12 24Z",
    fill: "#D80027"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.5087 9.80554L12.4933 11.1623L14.0879 10.6453L13.1017 12.0009L14.0862 13.3577L12.4922 12.8387L11.5061 14.1943L11.5071 12.518L9.91309 11.999L11.5077 11.482L11.5087 9.80554Z",
    fill: "#F0F0F0"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.82198 15.3913C6.94905 15.3913 5.43067 13.8729 5.43067 12C5.43067 10.127 6.94905 8.60867 8.82198 8.60867C9.40595 8.60867 9.95542 8.75638 10.4351 9.0163C9.68256 8.28027 8.65333 7.82605 7.51764 7.82605C5.21242 7.82605 3.34375 9.69477 3.34375 11.9999C3.34375 14.3051 5.21247 16.1738 7.51764 16.1738C8.65342 16.1738 9.68261 15.7196 10.4351 14.9836C9.95542 15.2436 9.40595 15.3913 8.82198 15.3913Z",
    fill: "#F0F0F0"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_5_34644"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}

export default __webpack_public_path__ + "media/e66394d1.svg";
export { SvgTurkey as ReactComponent };